"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var regOriginURL = /^(https?:)?\/\/[^/]+/;
exports.default = (function (url, baseURL) {
    if (url === void 0) { url = ''; }
    return "/" + url
        .replace(baseURL && url.startsWith(baseURL) ? baseURL : regOriginURL.test(url) ? regOriginURL : '', '')
        .replace(/^\//, '')
        .replace(/\/$/, '');
});
//# sourceMappingURL=createRelativePath.js.map